// @ts-ignore
import messages from 'constants/messages';

type FormValues = {
  deploymentEnvironment?: string;
  password?: string;
  applicationName?: string;
  description?: string;
};

type ValidationErrors = {
  password?: string;
  deploymentEnvironment?: string;
};

export default (values: FormValues) => {
  const errors: ValidationErrors = {};

  if (!values.deploymentEnvironment) {
    errors.deploymentEnvironment =
      messages.ENVIRONMENTS.DEPLOYMENT_ENVIRONMENT.REQUIRED;
  }

  if (!values.password) {
    errors.password = messages.ENVIRONMENTS.DASHBOARD_PASSWORD.REQUIRED;
  }

  return errors;
};
